import { Component } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { filter, map } from 'rxjs';

@Component({
	selector: 'app-breadcrumb',
	templateUrl: './breadcrumb.component.html',
	styleUrl: './breadcrumb.component.scss'
})
export class BreadcrumbComponent {
	items: MenuItem[] = [];
	currentUrl: string = '';

	constructor(
		private router: Router,
		private activatedRoute: ActivatedRoute
	) {}

	ngOnInit() {
		this.createBreadcrumbsOnInit();

		this.router.events
			.pipe(
				filter((event: any): event is NavigationEnd => event instanceof NavigationEnd),
				map(() => this.activatedRoute),
				map((route: ActivatedRoute) => {
					while (route.firstChild) route = route.firstChild;
					return route;
				}),
				filter((route: ActivatedRoute) => route.outlet === 'primary'),
				map((route: ActivatedRoute) => route.snapshot)
			)
			.subscribe((snapshot: any) => {
				this.currentUrl = this.router.url;
				this.items = this.createBreadcrumbs(snapshot);
			});
	}

	private createBreadcrumbs(snapshot: any): MenuItem[] {
		const breadcrumbs: MenuItem[] = [];
		let url = '';

		/** default breadcrumb for home page to make
		 * sure Home is on breadcrumb on initial page load */
		breadcrumbs.push({
			label: '',
			routerLink: ['/'],
			icon: 'pi pi-home'
		});

		snapshot.pathFromRoot.forEach((route: any) => {
			const breadcrumb = route.data?.breadcrumb;
			if (breadcrumb) {
				const path = route.url.map((segment: any) => segment.path).join('/');
				url += `/${path}`;

				if (!breadcrumbs.some((bc) => bc.label === breadcrumb)) {
					// prevent dup breadcrumb items
					breadcrumbs.push({
						label: route.data.breadcrumb,
						routerLink: [url],
						icon: route.data.icon || ''
					});
				}
			}
		});

		return breadcrumbs;
	}

	private createBreadcrumbsOnInit(): void {
		let currentRoute = this.activatedRoute.root;
		let url = '';
		const breadcrumbs: MenuItem[] = [];

		breadcrumbs.push({
			label: '',
			routerLink: ['/'],
			icon: 'pi pi-home'
		});

		while (currentRoute) {
			const breadcrumb = currentRoute.snapshot.data['breadcrumb'];

			if (breadcrumb && !breadcrumbs.some((b) => b.label === breadcrumb)) {
				// prevent dup breadcrumb items
				const path = currentRoute.snapshot.url.map((segment) => segment.path).join('/');
				url += `/${path}`;

				breadcrumbs.push({
					label: currentRoute.snapshot.data['breadcrumb'],
					routerLink: [url],
					icon: currentRoute.snapshot.data['icon'] || ''
				});
			}

			currentRoute = currentRoute.firstChild!;
		}

		this.items = breadcrumbs;
	}

	isActive(item: MenuItem): boolean {
		return this.currentUrl === item.routerLink?.join('/');
	}
}
